import Control from 'ol/control/Control';
import {fromLonLat} from "ol/proj";
import {PhotovoltaikcheckConstants} from "../photovoltaikcheck.constants";

export class GeolocationControl extends Control {
  constructor(customOptions) {
    const options = customOptions || {};

    const button = document.createElement('button');
    button.innerHTML = '📍'; // oder ein passendes Icon

    const element = document.createElement('div');
    element.className = 'ol-unselectable ol-control';
    element.style.top = '55px';
    element.style.left = '8px';
    element.appendChild(button);

    super({
      element,
      target: options.target
    });

    button.addEventListener('click', this.handleGeolocation.bind(this), false);
  }

  handleGeolocation(event: Event) {
    event.preventDefault();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        const coords = [pos.coords.longitude, pos.coords.latitude];
        const olCoords = fromLonLat(coords);
        this.getMap().getView().animate({
          center: olCoords,
          zoom: PhotovoltaikcheckConstants.MAP_GELOCATION_ZOOM
        });
      }, (err) => {
        console.error('Geolocation error:', err);
      });
    }
  }
}
